import { CustomListItemApi, WebApiCustomListsDtoChangeCustomListItemMembersDto, WebApiCustomListsDtoCreateBulkCustomListDto, WebApiCustomListsDtoCreateCustomListItemDto, WebApiCustomListsDtoCustomListItemDto } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";
import { WebApiCustomListsDtoUpdateCustomListItemDto } from "../Repository/eventbookyapi";

export abstract class CustomListItemService {
    public static GetItems = async (listId: number) => {
        return new CustomListItemApi(GetApiConfiguration()).listCustomListIdGet({ customListId: listId });
    };

    public static CreateCustomListItem = async (newItem: WebApiCustomListsDtoCreateCustomListItemDto) => {
        return new CustomListItemApi(GetApiConfiguration()).createPost({ webApiCustomListsDtoCreateCustomListItemDto: newItem });
    };

    public static CreateBulkCustomItems = async (newItems: WebApiCustomListsDtoCreateBulkCustomListDto) => {
        return new CustomListItemApi(GetApiConfiguration()).bulkCreatePost({ webApiCustomListsDtoCreateBulkCustomListDto: newItems });
    };

    public static DeleteCustomListItem = async (itemId: number) => {
        return new CustomListItemApi(GetApiConfiguration()).idDelete({ id: itemId });
    };

    public static ChangeMembershipConnection = async (itemId: number, dto: WebApiCustomListsDtoChangeCustomListItemMembersDto) => {
        return new CustomListItemApi(GetApiConfiguration()).customListItemIdMembersPost({
            customListItemId: itemId,
            webApiCustomListsDtoChangeCustomListItemMembersDto: dto
        });
    }

    // Alias for better clarity
    public static ChangeCustomListItemMembers = CustomListItemService.ChangeMembershipConnection;

    public static UpdateCustomListItem = async (itemId: number, updateDto: WebApiCustomListsDtoUpdateCustomListItemDto) => {

        return new CustomListItemApi(GetApiConfiguration()).updateIdPost({
            id: itemId,
            webApiCustomListsDtoUpdateCustomListItemDto: updateDto
        });
    };
}


